export enum Position {
    START = 'start',
    CENTER = 'center',
    END = 'end',
    RIGHT = 'right',
    LEFT = 'left',
    BOTTOM = 'bottom',
    TOP = 'top',
}
